export default __webpack_public_path__ + "static/media/meetingusericon.d52afe1c.svg";